import { Box, Divider, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import CoverageScoreLabel from "../../../../dashboard/mssp_widgets/stack_utilization_coverage/CoverageScoreLabel";
import { AssetTypeInfo } from "../../../../stack/assets/components/constants";
import { iconsAsset } from "../../../../stack/environment/icons/iconExport";
import TrendIndicator from "../../TrendIndicator";

const AssetCard = ({ name, assetType, value, coverage, trend }) => {
  const colors = useColors();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        borderRadius: "10px",
        backgroundColor: colors.common_white,
        padding: "12px",
        gap: "12px",
        boxShadow: "0px 0px 4px 0px " + colors.primary_48percent,
        minWidth: "265px",
        minHeight: "120px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: "32px",
            height: "32px",
            backgroundColor: colors.primary_8percent,
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: colors.primary_main,
            padding: "8px",
          }}
        >
          <SvgToIcon
            IconLogo={AssetTypeInfo[assetType]?.icon || iconsAsset["Other"]}
            style={{ width: "24px", height: "24px" }}
          />
        </Box>
        <Typography variant="subtitle2">{name}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            minWidth: "40%",
          }}
        >
          <Typography variant="caption" sx={{ color: colors.text_secondary }}>
            Attack Scenarios
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography variant="body2">{value}</Typography>
            {trend && trend["attack_scenarios_count"] && (
              <TrendIndicator
                data={trend["attack_scenarios_count"]}
                showPercent={false}
              />
            )}
          </Box>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ margin: "0px 10px", color: colors.grey_20percent }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            minWidth: "40%",
          }}
        >
          <Typography variant="caption" sx={{ color: colors.text_secondary }}>
            Coverage
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 0.5,
              alignItems: "center",
            }}
          >
            <CoverageScoreLabel
              value={coverage < 0 ? null : coverage}
              sx={{ borderRadius: "10px", height: "20px" }}
            />
            {trend && trend["coverage"] && (
              <TrendIndicator data={trend["coverage"]} showPercent={true} />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AssetCard;
